package com.hipsheep.kore.model.network

import io.ktor.client.engine.*
import io.ktor.client.engine.js.*

internal actual val KTOR_HTTP_CLIENT_ENGINE: HttpClientEngine
    get() = Js.create()